import script from "./applet.vue?vue&type=script&setup=true&lang=js"
export * from "./applet.vue?vue&type=script&setup=true&lang=js"

import "./applet.vue?vue&type=style&index=0&id=64dd2d34&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64dd2d34"]])

export default __exports__